import { detect } from 'detect-browser';
import isMobileJs from 'ismobilejs';
export function getDeviceInfo() {
    var _a;
    const browserData = detect();
    const osName = (_a = ((browserData === null || browserData === void 0 ? void 0 : browserData.os) || '')) === null || _a === void 0 ? void 0 : _a.split(' ')[0].toLowerCase();
    const browserName = ((browserData === null || browserData === void 0 ? void 0 : browserData.name) || '').toLowerCase();
    const device = isMobileJs();
    return {
        osName,
        browserName,
        device,
    };
}
//# sourceMappingURL=getDeviceInfo.js.map